import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "d-flex align-center pb-0 toolbar-actions" }
const _hoisted_2 = {
  key: 1,
  class: "d-flex align-center pb-0 px-6"
}
const _hoisted_3 = { class: "ml-auto d-flex justify-end pb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toolbar-wrap", _ctx.isMobile?'mb-6':''])
  }, [
    _createElementVNode("h2", {
      class: _normalizeClass(_ctx.isMobile?'pt-3 mx-2 toolbar-title':'mx-8')
    }, _toDisplayString(_ctx.title.plural), 3),
    _createVNode(_component_v_row, {
      class: _normalizeClass(["align-center mt-0 mx-6", _ctx.isMobile?'':'mx-3'])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_tooltip, { location: "top" }, {
            activator: _withCtx(({ props }) => [
              ((_ctx.currentView === 'table' || _ctx.currentView === 'calendar' || _ctx.currentView === 'kanban') && _ctx.title.plural != 'Posters')
                ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                    variant: "plain",
                    class: "square-btn",
                    icon: "",
                    onClick: _ctx.openFilters
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("mdi mdi-filter")
                        ])),
                        _: 1,
                        __: [5]
                      }),
                      (_ctx.activeFilterCount > 0)
                        ? (_openBlock(), _createBlock(_component_v_badge, {
                            key: 0,
                            content: _ctx.activeFilterCount,
                            color: "primary",
                            overlap: "",
                            style: {"position":"absolute","top":"10px","right":"10px"}
                          }, null, 8, ["content"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1040, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _cache[6] || (_cache[6] = _createTextVNode(" Filtros "))
            ]),
            _: 1,
            __: [6]
          }),
          _createVNode(_component_v_tooltip, { location: "top" }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps(props, {
                variant: "plain",
                class: "square-btn",
                icon: "",
                onClick: _ctx.openPreferences
              }), {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("mdi mdi-cog")
                    ])),
                    _: 1,
                    __: [7]
                  })
                ]),
                _: 2
              }, 1040, ["onClick"])
            ]),
            default: _withCtx(() => [
              _cache[8] || (_cache[8] = _createTextVNode(" Preferencias "))
            ]),
            _: 1,
            __: [8]
          }),
          (_ctx.title.plural == 'Ventas' || _ctx.title.plural == 'Cotizaciones'|| _ctx.title.plural == 'Clientes'|| _ctx.title.plural == 'Prospectos')
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 0,
                location: "top"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    variant: "plain",
                    class: "square-btn",
                    icon: "",
                    onClick: _ctx.openExport
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("mdi mdi-download")
                        ])),
                        _: 1,
                        __: [9]
                      })
                    ]),
                    _: 2
                  }, 1040, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createTextVNode(" Exportar CSV "))
                ]),
                _: 1,
                __: [10]
              }))
            : _createCommentVNode("", true),
          (_ctx.showTotalsToggle)
            ? (_openBlock(), _createBlock(_component_v_tooltip, {
                key: 1,
                location: "top"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    variant: "plain",
                    class: "square-btn",
                    icon: "",
                    color: _ctx.totalsVisible ? 'primary' : undefined,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-totals')))
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode("mdi-finance")
                        ])),
                        _: 1,
                        __: [11]
                      })
                    ]),
                    _: 2
                  }, 1040, ["color"])
                ]),
                default: _withCtx(() => [
                  _cache[12] || (_cache[12] = _createTextVNode(" Totales "))
                ]),
                _: 1,
                __: [12]
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_spacer),
        (_ctx.showTabs && _ctx.tabs?.length)
          ? (_openBlock(), _createBlock(_component_v_tabs, {
              key: 0,
              modelValue: _ctx.selectedTab,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTab) = $event)),
              class: "mx-md-4 pt-7 pt-md-0",
              density: "comfortable",
              color: "primary",
              stacked: _ctx.isMobile
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                  return (_openBlock(), _createBlock(_component_v_tab, {
                    key: tab.value ?? 'all',
                    value: tab.value,
                    class: "mr-8",
                    style: {"height":"30px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "stacked"]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_spacer),
        (_ctx.currentView == 'grid' || _ctx.currentView == 'card')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[15] || (_cache[15] = _createTextVNode(" Ordenar por: ")),
              _createVNode(_component_v_autocomplete, {
                modelValue: _ctx.sortBy,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sortBy) = $event)),
                items: _ctx.sortableHeaders,
                "item-title": "title",
                "item-value": "value",
                density: "compact",
                style: {"max-width":"200px"},
                class: "mx-4",
                "hide-details": "",
                variant: "outlined"
              }, null, 8, ["modelValue", "items"]),
              _createVNode(_component_v_btn, {
                variant: "plain",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.direction === 'asc' ? (_ctx.direction = 'desc') : (_ctx.direction = 'asc'))),
                density: "compact",
                style: {"min-width":"0px"},
                class: "px-0"
              }, {
                default: _withCtx(() => [
                  (_ctx.direction === 'asc')
                    ? (_openBlock(), _createBlock(_component_v_icon, { key: 0 }, {
                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createTextVNode("mdi-arrow-up")
                        ])),
                        _: 1,
                        __: [13]
                      }))
                    : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode("mdi-arrow-down")
                        ])),
                        _: 1,
                        __: [14]
                      }))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "before-create", {}, undefined, true),
          (!_ctx.isMobile && !!_ctx.onCreate && _ctx.$can(_ctx.moduleName.toLowerCase()+'.create') && (_ctx.title.plural != 'Ventas' || !_ctx.IS_DOMINIOMEDIOS) && _ctx.title.plural != 'Facturación' && _ctx.title.plural != 'Continuidad' && _ctx.title.plural != 'Cancelaciones')
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                color: "primary",
                class: "mr-6 mt-2 elevation-0",
                onClick: _ctx.openCreateForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Crear " + _toDisplayString(_ctx.title.singular), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.filteredViewModes.length>1)
            ? (_openBlock(), _createBlock(_component_v_btn_toggle, {
                key: 1,
                mandatory: "",
                modelValue: _ctx.currentView,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentView) = $event)),
                color: "primary",
                variant: "text"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredViewModes, (mode) => {
                    return (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: mode.value,
                      location: "top"
                    }, {
                      activator: _withCtx(({ props: tooltipProps }) => [
                        _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, tooltipProps, {
                          class: "square-btn ma-2",
                          icon: "",
                          value: mode.value
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(mode.icon), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1040, ["value"])
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(mode.label), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isMobile && _ctx.title.plural != 'Ventas' && _ctx.title.plural != 'Facturación' && _ctx.title.plural != 'Continuidad' && _ctx.title.plural != 'Cancelaciones')
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 2,
              icon: "",
              class: "fab-btn",
              onClick: _ctx.openCreateForm
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: _ctx.isDarkMode?'white':'black'
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode("mdi-plus")
                  ])),
                  _: 1,
                  __: [16]
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["class"])
  ], 2))
}